import enErrorMessages from '@/dealroadshow/ui/translations/errorMessages/locales/en/translation.json';
import jaErrorMessages from '@/dealroadshow/ui/translations/errorMessages/locales/ja/translation.json';

export const errorResources = {
  en: { errorMessages: enErrorMessages },
  ja: { errorMessages: jaErrorMessages },
} as const;

export function loadErrorResources() {
  return errorResources;
}
